function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.0145 21.1042C18.7624 21.365 18.3277 21.365 18.0669 21.1042L15.6128 18.6527C15.6129 18.6526 15.6128 18.6527 15.6128 18.6527L2.75107 5.80408C2.75104 5.80411 2.7511 5.80404 2.75107 5.80408L0.888305 3.94301C0.63619 3.6909 0.63619 3.24753 0.888305 2.99541C1.14911 2.7346 1.58379 2.7346 1.8446 2.99541L19.0145 20.1566C19.2753 20.4174 19.2666 20.8434 19.0145 21.1042Z",
  fill: "#878793"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17 16.2127C17 16.3821 16.9899 16.5445 16.9701 16.6996L5.28414 5.01953H14.3386C16.0587 5.01953 17 6.0122 17 7.73224V16.2127Z",
  fill: "#878793"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M2.22512 6.69215C2.1214 7.00064 2.06641 7.34832 2.06641 7.73224V16.2127C2.06641 17.9242 3.0933 18.9168 4.81335 18.9168H14.2531C14.3223 18.9168 14.3904 18.9152 14.4574 18.912L2.22512 6.69215Z",
  fill: "#878793"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18 14.4926L21.0212 17.1882C21.3121 17.445 21.6544 17.6075 21.9625 17.6075C22.63 17.6075 23.0664 17.1198 23.0664 16.4181V7.51831C23.0664 6.8166 22.63 6.32882 21.9625 6.32882C21.6544 6.32882 21.3121 6.49141 21.0212 6.74814L18 9.43518V14.4926Z",
  fill: "#878793"
});

function SvgIconCameraOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCameraOff);
export default __webpack_public_path__ + "static/media/icon-camera-off.909b2b95.svg";
export { ForwardRef as ReactComponent };